<script setup>
defineProps({
  unit: {
    type: Object,
    required: true,
  },
});

const formatDate = (value) => {
  if (!value) return "-";
  return new Intl.DateTimeFormat("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(value));
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">ข้อมูลผู้พักอาศัย</h5>
          <div class="text-muted small">ข้อมูลติดต่อและสถานะการอยู่อาศัย</div>
        </div>
        <div class="resident-avatar bg-primary-subtle text-primary">
          <i class="bi bi-person"></i>
        </div>
      </div>

      <template v-if="unit.residentName">
        <div class="mb-4">
          <div class="fw-bold fs-5">{{ unit.residentName }}</div>
          <div class="text-muted">เจ้าของยูนิต</div>
        </div>

        <div class="vstack gap-3">
          <div class="info-row">
            <i class="bi bi-telephone text-primary"></i>
            <div>
              <div class="info-label">เบอร์โทรศัพท์</div>
              <div class="info-value">{{ unit.phone || "-" }}</div>
            </div>
          </div>

          <div class="info-row">
            <i class="bi bi-envelope text-primary"></i>
            <div>
              <div class="info-label">อีเมล</div>
              <div class="info-value">{{ unit.email || "-" }}</div>
            </div>
          </div>

          <div class="info-row">
            <i class="bi bi-calendar-check text-primary"></i>
            <div>
              <div class="info-label">วันที่เริ่มเข้าอยู่</div>
              <div class="info-value">{{ formatDate(unit.moveInDate) }}</div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="empty-box text-center py-4">
          <i class="bi bi-house-dash fs-1 text-secondary d-block mb-3"></i>
          <div class="fw-semibold mb-1">ยังไม่มีผู้พักอาศัย</div>
          <div class="text-muted small">
            ยูนิตนี้ยังไม่ได้ผูกข้อมูลเจ้าของหรือผู้เช่า
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style scoped>
.resident-avatar {
  width: 56px;
  height: 56px;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
}
</style>
